import * as localforage from "localforage";
import { url } from "./apiSetup";
import { setToken } from "./getToken";
import Cookies from "js-cookie";
import { getSiteMainDomain } from "@/helpers/utils";
import casLogin from "@/containers/casLogin";
// import { phpRequest } from "./phpRequest";

export const authLogout = async (recordLogut, casLogOut) => {
  function sendData(path, parameters, method = "post") {
    console.log("Log out");
    const form = document.createElement("form");
    form.method = method;
    form.action = path;
    document.body.appendChild(form);

    for (const key in parameters) {
      const formField = document.createElement("input");
      formField.type = "hidden";
      formField.name = key;
      formField.value = parameters[key];

      form.appendChild(formField);
    }
    form.submit();
  }
  setToken(null);
  const token = await localforage.getItem("token");
  await localforage.clear();
  if (recordLogut) {
    localStorage.setItem("lastLogutAt", Date.now());
  }
  Cookies.remove("no_2fa", {
    domain: "." + getSiteMainDomain()
  });
  
  if (casLogOut) {
    await sendData(`${url}/cas/logout`, { token });
  } else {
    fetch(`${url}/api/v1/cas/clear-cookie`, {credentials: 'include'})
    // todo 清理cookie
    casLogin()
  }
  //await sendData('https://localhost:8089/logout', {query: 'log out'});

  return true;

  // await phpRequest.post("/member/logout");
  // localforage.clear();
};
